import { createContext } from 'react';

const AuthContext = createContext({
  user: null,
  isAuthenticated: false,
  authLoading: true,
  login: async () => {},
  logout: () => {},
  refreshCurrentUser: async () => {},
});

export default AuthContext;
